import { render } from "./ProjectEdit.vue?vue&type=template&id=fc061686"
import script from "./ProjectEdit.vue?vue&type=script&lang=js"
export * from "./ProjectEdit.vue?vue&type=script&lang=js"

import exportComponent from "/home/paperspace/thehrway-basic/src/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__